import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import SectionCard from "../components/SectionCard"
import { useGetApprovalLogQuery } from "shared/redux/endpoints/procurement"

const RelatedApprovalTab = ({ requestId }) => {
  const { data, isFetching } = useGetApprovalLogQuery(requestId, {
    skip: !requestId,
  })
  const rows = data || []

  if (isFetching) return <MDTypography variant="body2">Loading…</MDTypography>
  if (rows.length === 0)
    return (
      <MDTypography variant="body2" color="text">
        No approval activity yet.
      </MDTypography>
    )

  return (
    <SectionCard title="Approval Activity" icon="history" mb={0}>
      {rows.map((r, i) => (
        <MDBox key={i} p={2} mb={1} bgColor="grey-100" borderRadius="lg">
          <MDTypography variant="button" fontWeight="medium">
            {r.action} — {r.actorName || r.actorRole}
          </MDTypography>
          <MDTypography variant="caption" color="text" display="block">
            {r.at}
          </MDTypography>
          {r.note && (
            <MDTypography variant="body2" mt={1}>
              {r.note}
            </MDTypography>
          )}
        </MDBox>
      ))}
    </SectionCard>
  )
}

export default RelatedApprovalTab
